import React, { useState, useEffect } from "react";
import { getTemplateDetails, getRecentBookingDetails } from "./templateUtils";
import CustomAutoCompleteRoot from "../../common/CustomAutoComplete";
import { useHistory } from "react-router-dom";
import { checkIsBackButtonAction } from "./formUtils";
import { NOTIFICATION_MESSAGE_TYPE } from "../../constants";
import { clearItemFromSessionStorage } from "../../utils/StorageUtils";
import { useTranslation } from "react-i18next";
import Messages from "../../constants/Messages";
import backIcon from "../../assets/images/chevron-left.svg";
import SearchPanelMessage from "./SearchPanelMessage";

const SearchHeader = ({
	searchFormData,
	setNotLeave,
	updateTemplateView,
	setUpdateTemplateView,
	templateParam,
	serialNo,
	listTemplateNamesResponse,
	listDraftsResponse,
	setSearchFormDataToState,
	setAdditionalInfoData,
	setIsLoading,
	setTemplateView,
	setTemplateName,
	setSerialNumber,
	shippingItems,
	handleClear,
	isModifyBooking,
	awbNo,
	setAlertMessage,
	setTemplateSuccess,
	setArrivalDate,
	getlistDraftsResponse,
	setSelectedTemplate,
	selectedTemplate,
	listQuotesResponse,
	listQuoteError,
	listTemplateNamesError,
	listDraftsError,
	setNotificationMessage,
	setNotificationType,
	isSeasonalBooking,
	setInitialList,
	navigateBack,
	isMultipleBookingEdit,
}) => {
	const history = useHistory();

	const [isBookingDetailsLoading, setIsBookingDetailsLoading] = useState(false);

	//for multilingual translation
	const { t } = useTranslation(["labels", "errors"]);

	//=====changing properties of draft listingh array=====//

	const newArrayOfObj = listDraftsResponse?.bookingDraft?.map(
		({ draftName: templateName, ...rest }) => ({
			templateName,
			...rest,
		})
	);

	//====================================================//

	const handleClearForm = (e) => {
		handleClear();
		setSelectedTemplate("");
		setNotLeave(false);
	};

	const handleChangeTemplate = async (templateVal) => {
		setSelectedTemplate(templateVal);
	};

	const handleSelectTemplate = async (templateVal) => {
		setSelectedTemplate(templateVal);
		populateTemplateDetailsInForm(templateVal?.templateName, templateVal?.type);
	};

	const handleSelectedItem = async (name, type) => {
		setSelectedTemplate(name);
		populateTemplateDetailsInForm(name, type);
	};

	const populateTemplateDetailsInForm = async (templateName, type) => {
		let templateParameters = await getTemplateDetails(
			setSearchFormDataToState,
			setAdditionalInfoData,
			templateName,
			type,
			setIsLoading,
			getlistDraftsResponse
		);

		setTemplateView(true);
		if (templateParameters) {
			setTimeout(function () {
				setSearchFormDataToState(null);
				setAdditionalInfoData({
					type: null,
					pharma: {},
				});
				setSearchFormDataToState(templateParameters);
				if (templateParameters.additionalInfo) {
					setAdditionalInfoData(templateParameters.additionalInfo);
				}
				setIsLoading(false);
			}, 1000);
		} else {
			if (templateParameters === null) {
				type === "DRAFT"
					? setAlertMessage(t(Messages.NO_DRAFT_FOUND, { ns: "errors" }))
					: setAlertMessage(t(Messages.TEMP_NOT_FOUND, { ns: "errors" }));
				setTemplateSuccess(false);
				window.scrollTo(0, 0);
				setIsLoading(false);
			}
		}
	};

	const populateQuoteDetailsInSummary = (quotationName) => {
		history.push(`/booking/summary/${quotationName}`);
	};

	const backToMultipleBooking = () => {
		history.push("/permanent-booking");
	};

	useEffect(() => {
		async function populateTemplate() {
			if (templateParam && templateParam !== "" && serialNo && serialNo != "") {
				setUpdateTemplateView(true);
				setTemplateName(templateParam);
				setSerialNumber(serialNo);
				populateTemplateDetailsInForm(templateParam);
			}
		}

		populateTemplate();
	}, [shippingItems]);

	useEffect(() => {
		async function populateRecentBookingDetails() {
			if (
				!isBookingDetailsLoading &&
				((shippingItems &&
					shippingItems.length > 0 &&
					awbNo) ||
				(isMultipleBookingEdit && shippingItems && shippingItems.length > 0))
			) {
				setIsBookingDetailsLoading(true);
				const data = await getRecentBookingDetails(
					setSearchFormDataToState,
					setAdditionalInfoData,
					shippingItems,
					awbNo,
					setIsLoading,
					isModifyBooking,
					isMultipleBookingEdit,
					setAlertMessage
				);
				setTemplateView(true);
				//setSearchFormDataToState(data)
				if (data && !data.errorDescription) {
					setTimeout(function () {
						//setSearchFormDataToState(null)
						setArrivalDate(null);
						setAdditionalInfoData({
							type: null,
							pharma: {},
						});
						//setSearchFormDataToState(data)
						if (data.additionalInfo) {
							setAdditionalInfoData(data.additionalInfo);
						}
						setIsLoading(false);
						setIsBookingDetailsLoading(false);
					}, 1000);
				} else if (data && data.errorDescription) {
					setAlertMessage(`${awbNo} - ${data.errorDescription}`);
					setTemplateSuccess(false);
					window.scrollTo(0, 0);
					setIsBookingDetailsLoading(false);
				}
			}
		}
		let isBackButtonAction = checkIsBackButtonAction(history);
		if (isBackButtonAction && searchFormData) {
			setTemplateView(true);
		} else {
			populateRecentBookingDetails();
		}
	}, isMultipleBookingEdit ? [shippingItems, isMultipleBookingEdit] : [shippingItems]);
	useEffect(() => {
		if (awbNo && !checkIsBackButtonAction(history)) {
			setIsLoading(true);
			setSearchFormDataToState(null);
		}
	}, [awbNo]);

	const handleCancelAction = () => {
		handleClear();
		history.push("/manage-template");
	};

	return (
		<>
			{!isMultipleBookingEdit && (
				// <div class="search-panel__booking-title">
					!updateTemplateView && !isModifyBooking && (
						<div class="search-panel__booking-title">
						<CustomAutoCompleteRoot
							draftList={listDraftsResponse}
							templateList={listTemplateNamesResponse}
							quoteList={listQuotesResponse}
							handleSelectedItem={handleSelectedItem}
							setSelectedItem={setSelectedTemplate}
							selectedItem={selectedTemplate}
							populateQuoteDetailsInSummary={populateQuoteDetailsInSummary}
							listQuoteError={listQuoteError}
							listTemplateNamesError={listTemplateNamesError}
							listDraftsError={listDraftsError}
							isSeasonalBooking={isSeasonalBooking}
							setInitialList={setInitialList}
						/>
						</div>
					)
				
			)}
			

			{isSeasonalBooking &&
				listTemplateNamesResponse?.templateList?.length == 0 && (
					<SearchPanelMessage
						listTemplateNamesResponse={listTemplateNamesResponse}
						isSeasonalBooking={isSeasonalBooking}
						selectedTemplate={selectedTemplate}
					/>
				)}
			{isSeasonalBooking && selectedTemplate?.length === 0 ? (
				<>
					<div className="footer-button-row">
						{navigateBack && (
							<button
								type="submit"
								value="Submit"
								className="secondary-button mr-2"
								onClick={(e) => {
									setInitialList();
								}}
							>
								{t("COMMON.BACK_BUTTON")}
							</button>
						)}
						<button
							value="Create new template"
							className="primary-button mr-2"
							onClick={(e) => {
								history.push("/booking/search");
							}}
						>
							{t("TEMPLATES.CREATE_TEMPLATE")}
						</button>
					</div>
				</>
			) : (
				<></>
			)}
			{updateTemplateView && (
				<div className="template-header-wrapper">
					<div
						className="d-flex back-icon-txt-container align-items-center"
						onClick={handleCancelAction}
					>
						<img src={backIcon} alt="Share" className="back-icon" />
						<div className="label-back">{t("COMMON.BACK_BUTTON")}</div>
					</div>
					<div className="d-flex">
						<span className="modify-template-text">
							{t("MNGTMPLT.MODIFY_TEMPLATE")} -{" "}
						</span>
						<span className="modify-template-name">{templateParam}</span>
					</div>
				</div>
			)}
			{isMultipleBookingEdit && (
				<div className="multiple-edit-header-section">
					<div className="back-nav-section" onClick={backToMultipleBooking}>
						<img src={backIcon} alt="Share" className="back-icon" />
						<label className="back-label">{t("COMMON.BACK_BUTTON")}</label>
					</div>
					<label className="multi-booking-edit-label">
						{t("BOOKING.MODIFY_MULT_BOOKING")}
					</label>
				</div>
			)}

			{!updateTemplateView && isModifyBooking && (
				<div
					style={{ display: "flex", justifyContent: "space-between" }}
					className="title-content modify_temp"
				>
					 <h3>
      {t("COMMON.MODIFYBOOKING")}
      {awbNo ? ` - ${awbNo}` : ""}
    </h3>
				</div>
			)}
		</>
	);
};

export default SearchHeader;
